// extracted by mini-css-extract-plugin
export var section = "styles-module--section--HucS7";
export var subtitle = "styles-module--subtitle--KS+Ba";
export var textArea = "styles-module--textArea--eHb4-";
export var title = "styles-module--title--rpxuq";